export default __webpack_public_path__ + "950f15a938f201b044b85025a1357d5d.svg";